import type { Eip1193Provider } from "./wallet";
import { chains } from "./chains";

export const walletConnectProjectId = (import.meta.env.VITE_WALLETCONNECT_PROJECT_ID || "").trim();
export const walletConnectConfigured = Boolean(walletConnectProjectId);

let cachedProvider: Eip1193Provider | null = null;

export async function connectWalletConnect(): Promise<Eip1193Provider> {
  if (!walletConnectConfigured) throw new Error("WalletConnect is not configured on this deployment yet.");

  if (!cachedProvider) {
    const { EthereumProvider } = await import("@walletconnect/ethereum-provider");
    const optionalChains = chains.map((chain) => chain.viem.id) as [number, ...number[]];
    const rpcMap = Object.fromEntries(chains.map((chain) => [chain.viem.id, chain.viem.rpcUrls.default.http[0]])) as Record<number, string>;
    const provider = await EthereumProvider.init({
      projectId: walletConnectProjectId,
      optionalChains,
      showQrModal: true,
      rpcMap,
      metadata: {
        name: "Fresh Mint",
        description: "Fresh Mint cross-chain stablecoin settlement",
        url: window.location.origin,
        icons: []
      }
    });
    cachedProvider = provider as unknown as Eip1193Provider;
  }

  const connectable = cachedProvider as Eip1193Provider & { connect?: () => Promise<unknown> };
  await connectable.connect?.();
  return cachedProvider;
}

export async function disconnectWalletConnect(provider: Eip1193Provider | null) {
  if (!provider) return;
  const disconnectable = provider as Eip1193Provider & { disconnect?: () => Promise<void> };
  try { await disconnectable.disconnect?.(); } catch { /* noop */ }
  cachedProvider = null;
}
